import App from './app';
export { default as App } from './app';
import { UserID, UserAnonymousID, Metadata, RawCustomEvent, CustomIssue } from './messages';
import * as _Messages from './messages';
export const Messages = _Messages;
import Connection from './modules/connection';
import Console from './modules/console';
import Exception, { getExceptionMessageFromEvent, getExceptionMessage } from './modules/exception';
import Img from './modules/img';
import Input from './modules/input';
import Mouse from './modules/mouse';
import Timing from './modules/timing';
import Performance from './modules/performance';
import Scroll from './modules/scroll';
import Viewport from './modules/viewport';
import Longtasks from './modules/longtasks';
import CSSRules from './modules/cssrules';
import { IN_BROWSER } from './utils';
function isOptions(obj) {
    if (obj == null) {
        return false;
    }
    if (typeof obj.projectID !== 'number') {
        return false;
    }
    if (typeof obj.sessionID !== 'string' && obj.sessionID != null) {
        return false;
    }
    return true;
}
const CUSTOM_LEVELS = ['info', 'error'];
export default class API {
    constructor(options) {
        this.app = null;
        this.handleError = (e) => {
            if (e instanceof Error && this.app !== null) {
                this.app.send(getExceptionMessage(e, []));
            }
        };
        this.handleErrorEvent = (e) => {
            if ((e instanceof ErrorEvent ||
                ('PromiseRejectionEvent' in window && e instanceof PromiseRejectionEvent)) &&
                this.app !== null) {
                const msg = getExceptionMessageFromEvent(e);
                if (msg != null) {
                    this.app.send(msg);
                }
            }
        };
        if (!IN_BROWSER) {
            return;
        }
        if (!isOptions(options)) {
            console.error("Asayer: invalid options argument type. Please, check documentation on https://docs.asayer.io");
            return;
        }
        if (!options.__allow_not_secure && location.protocol !== 'https:') {
            console.error("Asayer: Your website must be publicly accessible and running on SSL in order for Asayer to properly capture and replay the user session.");
            return;
        }
        const doNotTrack = options.respectDoNotTrack && (navigator.doNotTrack == '1' || window.doNotTrack == '1');
        this.app = doNotTrack ||
            !('Map' in window) ||
            !('Set' in window) ||
            !('MutationObserver' in window) ||
            !('performance' in window) ||
            !('timing' in performance) ||
            !('startsWith' in String.prototype) ||
            !('Blob' in window) ||
            !('Worker' in window)
            ? null
            : new App(options.projectID, options.sessionID, options);
        if (this.app !== null) {
            Connection(this.app);
            Console(this.app, options);
            Exception(this.app, options);
            Img(this.app);
            Input(this.app, options);
            Mouse(this.app);
            Timing(this.app, options);
            Performance(this.app);
            Scroll(this.app);
            Viewport(this.app);
            Longtasks(this.app);
            CSSRules(this.app);
            window.__ASAYER__ = window.__ASAYER__ || this;
        }
        else {
            const req = new XMLHttpRequest();
            const orig = options.__fallback_origin || "https://ingest.asayer.io";
            req.open("POST", orig + "/v1/web/not-started");
            // no-cors issue only with text/plain or not-set Content-Type
            // req.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            req.send(JSON.stringify({
                trackerVersion: '5.6.8',
                projectID: options.projectID,
                doNotTrack,
            }));
        }
    }
    use(fn) {
        return fn(this.app);
    }
    active() {
        if (this.app === null) {
            return false;
        }
        return this.app.active();
    }
    start() {
        if (!IN_BROWSER) {
            console.error("Asayer: you are trying to start Tracker on a node.js environment. If you want to use Asayer with SSR, please, use componentDidMount or useEffect API for placing the `tracker.start()` line. Check documentation on https://docs.asayer.io");
            return;
        }
        if (this.app === null) {
            return;
        }
        this.app.start();
    }
    stop() {
        if (this.app === null) {
            return;
        }
        this.app.stop();
    }
    sessionID() {
        if (this.app === null) {
            return null;
        }
        return this.app.sessionID();
    }
    userID(id) {
        if (typeof id === 'string' && this.app !== null) {
            this.app.send(new UserID(id));
        }
    }
    userAnonymousID(id) {
        if (typeof id === 'string' && this.app !== null) {
            this.app.send(new UserAnonymousID(id));
        }
    }
    metadata(key, value) {
        if (typeof key === 'string' &&
            typeof value === 'string' &&
            this.app !== null) {
            this.app.send(new Metadata(key, value));
        }
    }
    event(key, payload, level = 'info') {
        if (typeof key === 'string' && this.app !== null) {
            if (level === 'error') {
                return this.issue(key, payload);
            }
            if (level === 'info') {
                try {
                    payload = JSON.stringify(payload);
                }
                catch (e) {
                    return;
                }
                this.app.send(new RawCustomEvent(key, payload));
            }
        }
    }
    issue(key, payload) {
        if (typeof key === 'string' && this.app !== null) {
            try {
                payload = JSON.stringify(payload);
            }
            catch (e) {
                return;
            }
            this.app.send(new CustomIssue(key, payload));
        }
    }
}
